import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function TextMessage({ message, isPrimary, isLastInGroup }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const radius = !isPrimary
    ? isLastInGroup
      ? '1px 18px 18px 18px'
      : '1px 18px 18px 1px'
    : '18px 18px 18px 18px';

  return (
    <Box
      sx={{
        width: 'fit-content',
        maxWidth: 'fit-content',
        padding: '10px 16px',
        borderRadius: radius,
        bgcolor: isPrimary
          ? isDark
            ? 'rgba(32, 101, 209, 0.16)'
            : '#bbe3ff'
          : isDark
          ? 'rgba(255, 255, 255, 0.04)'
          : '#dadbdb',
        color: isDark ? 'text.primary' : '#1C1B1F',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        whiteSpace: 'pre-wrap',
        border: isPrimary
          ? isDark
            ? '1px solid rgba(32, 101, 209, 0.3)'
            : '1px solid rgba(0,122,255,0.1)'
          : isDark
          ? '1px solid rgba(255, 255, 255, 0.08)'
          : '1px solid rgba(0,0,0,0.05)',
        transition: 'all 0.2s ease',
      }}
    >
      <Typography
        sx={{
          fontSize: '1rem',
          lineHeight: 1.5,
          fontWeight: 500,
          fontFamily: 'inherit',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}

TextMessage.propTypes = {
  message: PropTypes.string,
  isPrimary: PropTypes.bool,
  isLastInGroup: PropTypes.bool,
};

export default TextMessage;
